import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && e.response.data?.detail === "SESSION_REPLACED" && localStorage.getItem("dss_token")) {
    localStorage.removeItem("dss_token");
    window.location.href = "/login?replaced=1";
  }
  return Promise.reject(e);
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dss_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const img = (u, w) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : w && u?.includes("images.unsplash.com") ? u.replace(/([?&])w=\d+/, `$1w=${w}`).replace(/([?&])q=\d+/, "$1q=70").replace("fm=jpg", "fm=webp") : u);

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const off = (p) => (p.mrp > p.price ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || JSON.stringify(x)).replace(/^Value error, /, "")).join(" ");
  return d.message || d.msg || String(d);
}
